export default __webpack_public_path__ + "e76b22fda80c1cdf6a477a9bc4de1154.svg";